import {DateSchema} from '@cohort/shared/schema/common';
import {NetworkSchema} from '@cohort/shared/schema/common/blockchain';
import {
  OwnershipObtentionTypeSchema,
  OwnershipStatusSchema,
} from '@cohort/shared/schema/common/ownerships';
import {PaginationParamsSchema} from '@cohort/shared/schema/common/pagination';
import {z} from 'zod';

export const NftASchema = z.object({
  smartContractAddress: z.string(),
  network: NetworkSchema,
  tokenId: z.number().int().min(1),
  transactionHash: z.string(),
  blockExplorerUrl: z.string(),
  openseaUrl: z.string(),
});
export type NftADto = z.infer<typeof NftASchema>;

export const DigitalAssetASchema = z.object({
  id: z.string().uuid(),
  tokenId: z.number().int().min(1),
  nft: NftASchema.nullable(),
  digitalAssetCollection: z.object({
    id: z.string().uuid(),
    internalName: z.string(),
    imageFileKey: z.string(),
  }),
  ownership: z
    .object({
      status: OwnershipStatusSchema,
      obtentionType: OwnershipObtentionTypeSchema,
      obtentionDate: DateSchema,
    })
    .nullable(),
});
export type DigitalAssetADto = z.infer<typeof DigitalAssetASchema>;

export const GetDigitalAssetsParamsASchema = PaginationParamsSchema.extend({
  userId: z.string(),
});
export type GetDigitalAssetsParamsADto = z.infer<typeof GetDigitalAssetsParamsASchema>;
